// import { loadScript } from "./utils/loaders";
import { nextIcon, playIcon, pauseIcon, muteIcon, unmuteIcon, fullscreenIcon, exitFullscreenIcon, nextArrow, closeIcon, heartIconFilled, heartIconOutlined, shareIcon } from "./components/Icons";
import { IVideo, IListing, IUser, ISource } from "./WidgetTvTypes";
import { observeCustomElement } from "./utils/observe";
import { fixedShuffle, jaccardSort } from "./utils/shuffle";
// import "./WidgetTvFonts.css";
// import "./WidgetTvStyles.css";
import { loadScript } from "./utils/loaders";
import { generateAds, appendViewerHeaders } from "./AdStack";
import { ICustomizations } from "./providers/types";
import { makeCustomizationController, getAttributeAnyCasing } from "./providers/Customizations";
import { iheartPlayer } from "./providers/iheartPlayer";
import { makeLikeProvider } from "./providers/likeProvider";
import { pushEvent, pushFirstAdViewed } from "./Events";
import { SellwildVideoElement } from "./VideoIMA";

interface SellwildTvElement extends HTMLElement {
  play: () => void
  pause: () => void
  manualPause: boolean
}

const { SLUG, NAME, TITLE, IU, AD_UNIT, CODE, VIDEOS, VIDEO_TAG_CACHE_COUNT, FLOAT, FLOAT_BEHAVIOR, LISTING_ID, USER_ID, AD_TYPE, SCHAIN_SID, S2S_CONFIG, AD_REFRESH_MAX, AD_REFRESH_INTERVAL, AD_DISABLE_DISPLAY, BANNER_ZID, BOTTOM_BANNER_ZID, MOBILE_BANNER_ZID, MOBILE_ZID, DISPLAY_ZID, BIDSTREAM_STACK, SCROLL_NEXT_TITLE, PRIMARY_COLOR, CSS, AUDIGENT, APPNEXUS, AMX, PUBMATIC, UNRULY, RUBICON, SONOBI, NOBID, CPMSTAR, INSTICATOR, YIELDMO, EPSILON, TRIPLELIFT, ONETAG, MINUTEMEDIA, SMAATO, SOVRN, IMPROVE_DIGITAL, EQUATIV, SHARETHROUGH, AD_GEO_BLOCK } = process.env

function sellwildTvController() {
  const elements = new Map<string, SellwildTvElement>();

  return {
    isReady: null as null | Promise<void>,
    mainVideos: [] as HTMLVideoElement[],
    async initialize() {
      if (this.isReady) return this.isReady;

      this.isReady = loadDependencies();

      return this.isReady;
    },
    observeVisibility (element: HTMLElement, floatBehavior: string, onVideoInView?: () => void) {
      let hasScrolledPast = false
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            videoInView(element)
          } else if (!entry.isIntersecting) { // Only if not intersecting and scrolled past
            if (floatBehavior === 'after' && !hasScrolledPast) {
              hasScrolledPast = true
              if (entry.boundingClientRect.top < 0) {
                videoLeftView(element)
              }
            } else {
              videoLeftView(element)
              if (onVideoInView) {
                onVideoInView() // NEED TO CALL FOR CORNER PLAYER
              }
            }
          }
        })
      }, {
        root: null,
        threshold: 0,
      })
      const wrapper = element.parentElement

      if (wrapper) {
        observer.observe(wrapper);
      }
      
      const adContainer = element.querySelector('[data-selector=ad]') as HTMLElement
      const close = element.querySelector('[data-selector=close]') as HTMLElement
      close.addEventListener('click', (ev) => {
        ev.stopPropagation()
        for (const video of this.mainVideos) {
          video.muted = true
        }
        element.classList.add('closed')

        const ad = adContainer.querySelector('sellwild-video') as (HTMLElement & { adsManager: any })
        if (ad && ad.adsManager) {
          ad.adsManager.pause()
          // ad.adsManager.setVolume(0)
        }
      })

      const that = this
      function videoInView (element: HTMLElement | null) {
        if (element) {
          element.classList.remove('corner')
          if (element.classList.contains('closed')) {
            for (const video of that.mainVideos) {
              video.muted = false
            }
          }
        }
        const ad = adContainer.querySelector('sellwild-video') as (HTMLElement & { adsManager: any })
        if (ad && ad.adsManager) {
          ad.adsManager.resume()
        }
        if (onVideoInView) onVideoInView() 
      }

      function videoLeftView (element: HTMLElement | null) {
        if (element && !(document as any).pictureInPictureElement) {
          element.classList.add('corner')
          if (!that.selectedMuted && element.classList.contains('closed')) {
            for (const video of that.mainVideos) {
              video.muted = true
            }
            const ad = adContainer.querySelector('sellwild-video') as (HTMLElement & { adsManager: any })
            if (ad && ad.adsManager) {
              ad.adsManager.pause()
            }
          }
        }
      }
    },
    currentMuted: true,
    selectedMuted: false,
    async elementAdded (el: HTMLElement) {
      const element = el as SellwildTvElement
      elements.set(element.id, element)

      await this.isReady


      const search = new URLSearchParams(window.location.search)
      const customizationsCtrl = makeCustomizationController(element, search)
      const slug = getAttributeAnyCasing(element, 'slug') || decodeURIComponent(SLUG || '') || search.get('slug') || ''
      const code = decodeURIComponent(CODE || '') || getAttributeAnyCasing(element, 'code') || search.get('code') || ''
      const name = getAttributeAnyCasing(element, 'name') || decodeURIComponent(NAME || '') || search.get('name') || ''
      const iu = getAttributeAnyCasing(element, 'iu') || decodeURIComponent(IU || '') || search.get('iu')
      const title = getAttributeAnyCasing(element, 'title') || TITLE || search.get('title')
      const adUnit = getAttributeAnyCasing(element, 'adUnit') || decodeURIComponent(AD_UNIT || '') || search.get('adUnit')
      const keywordsEl = document.querySelector('meta[name=keywords]') as HTMLElement
      const keywords = keywordsEl ? keywordsEl.getAttribute('content') || '' : ''
      const videoTagCacheCount = Number(getAttributeAnyCasing(element, 'videosTagCacheCount') || VIDEO_TAG_CACHE_COUNT || search.get('videosTagCacheCount')) || 0
      const videoTagCache = keywords.trim() && videoTagCacheCount ? `https://tbd4rmdvjk.execute-api.us-east-1.amazonaws.com/dev/playlist?keywords=${keywords.trim()}&count=${videoTagCacheCount}&v=1` : ''
      const cache = getAttributeAnyCasing(element, 'videos') || decodeURIComponent(VIDEOS || '') || search.get('videos')
      const userId = getAttributeAnyCasing(element, 'userId') || decodeURIComponent(USER_ID || '') || search.get('userId')
      const listingId = getAttributeAnyCasing(element, 'listingId') ||  decodeURIComponent(LISTING_ID || '') || search.get('listingId')
      const float = (getAttributeAnyCasing(element, 'float') || decodeURIComponent(FLOAT || '') || search.get('float')) === 'true'
      const floatBehavior = getAttributeAnyCasing(element, 'floatBehavior') || decodeURIComponent(FLOAT_BEHAVIOR || '') || search.get('floatBehavior') || 'after'

      const adType = getAttributeAnyCasing(element, 'adType') || AD_TYPE || search.get('adType')
      const schainSid = getAttributeAnyCasing(element, 'schainSid') || SCHAIN_SID || search.get('schainSid')
      const s2sConfig = getAttributeAnyCasing(element, 's2sConfig') || S2S_CONFIG || search.get('s2sConfig')
      const adRefreshMax = Number(getAttributeAnyCasing(element, 'adRefreshMax')) || Number(AD_REFRESH_MAX) || Number(search.get('adRefreshMax'))
      const adRefreshInterval = Number(getAttributeAnyCasing(element, 'adRefreshInterval')) || Number(AD_REFRESH_INTERVAL) || Number(search.get('adRefreshInterval'))
      const adDisableDisplay = String(getAttributeAnyCasing(element, 'adDisableDisplay') || AD_DISABLE_DISPLAY || search.get('adDisableDisplay')) === 'true'
      const bannerZid = getAttributeAnyCasing(element, 'bannerZid') || BANNER_ZID || search.get('bannerZid')
      const bottomBannerZid = getAttributeAnyCasing(element, 'bottomBannerZid') || BOTTOM_BANNER_ZID || search.get('bottomBannerZid')
      const mobileBannerZid = getAttributeAnyCasing(element, 'mobileBannerZid') || MOBILE_BANNER_ZID || search.get('mobileBannerZid')
      const mobileZids = parseNums(getAttributeAnyCasing(element, 'mobileZid') || MOBILE_ZID || search.get('mobileZid') || '')
      const displayZids = parseNums(getAttributeAnyCasing(element, 'displayZid') || DISPLAY_ZID || search.get('displayZid') || '')
      const bidstreamStack = Number(getAttributeAnyCasing(element, 'bidstreamStack') || BIDSTREAM_STACK || search.get('bidstreamStack') || 0)
      const scrollNextTitle = getAttributeAnyCasing(element, 'scrollNextTitle') || SCROLL_NEXT_TITLE || search.get('scrollNextTitle') || 'Scroll to Next Review'
      const audigent = Boolean(getAttributeAnyCasing(element, 'audigent') || AUDIGENT || search.get('audigent')) || false
      const targetBlank = getAttributeAnyCasing(element, 'targetBlank') !== 'false'
      const base = getAttributeAnyCasing(element, 'baseUrl')
      const baseUrl = typeof base === 'string' ? base : 'https://sellwild.com'
      const primaryColor = getAttributeAnyCasing(element, 'primaryColor') || PRIMARY_COLOR || search.get('primaryColor') || ''
      const css = getAttributeAnyCasing(element, 'css') || CSS || search.get('css') || ''

      if (primaryColor) {
        element.style.setProperty('--blue', primaryColor)
      }

      const attributes = {
        widgetType: 'tv',
        widgetName: name,
        code,
      }

      pushEvent({ event: 'view', attributes })

      element.addEventListener('click', (ev) => {
        if (!(ev.target instanceof HTMLElement)) return

        const element = ev.target.closest('a[href]:not([href=""])')
        if (!element) return
        
        const href = element.getAttribute('href')
        if (!href) return
        
        const event = element.getAttribute('data-event') || 'click'
        const action = element.getAttribute('data-event-action') || ''
        const label = element.getAttribute('data-event-label') || ''
        pushEvent({ event, action, label, attributes: { ...attributes, href } })
      })

      const ads = generateAds({
        slug,
        adType,
        schainSid,
        s2sConfig,
        adRefreshMax,
        adRefreshInterval,
        adDisableDisplay,
        bannerZid,
        bottomBannerZid,
        mobileBannerZid,
        mobileZids,
        displayZids,
        bidstreamStack,
        audigent,
        appnexus: customizationsCtrl.getObject('appnexus', APPNEXUS),
        amx: customizationsCtrl.getObject('amx', AMX), 
        pubmatic: customizationsCtrl.getObject('pubmatic', PUBMATIC), 
        unruly: customizationsCtrl.getObject('unruly', UNRULY), 
        rubicon: customizationsCtrl.getObject('rubicon', RUBICON), 
        sonobi: customizationsCtrl.getObject('sonobi', SONOBI), 
        nobid: customizationsCtrl.getObject('nobid', NOBID), 
        cpmstar: customizationsCtrl.getObject('cpmstar', CPMSTAR), 
        insticator: customizationsCtrl.getObject('insticator', INSTICATOR),
        yieldmo: customizationsCtrl.getObject('yieldmo', YIELDMO),
        epsilon: customizationsCtrl.getObject('epsilon', EPSILON),
        triplelift: customizationsCtrl.getObject('triplelift', TRIPLELIFT),
        onetag: customizationsCtrl.getObject('onetag', ONETAG),
        minutemedia: customizationsCtrl.getObject('minutemedia', MINUTEMEDIA),
        smaato: customizationsCtrl.getObject('smaato', SMAATO),
        sovrn: customizationsCtrl.getObject('sovrn', SOVRN), 
        improveDigital: customizationsCtrl.getObject('improveDigital', IMPROVE_DIGITAL), 
        equativ: customizationsCtrl.getObject('equativ', EQUATIV), 
        sharethrough: customizationsCtrl.getObject('sharethrough', SHARETHROUGH), 
        adGeoBlock: customizationsCtrl.getObject('adGeoBlock', AD_GEO_BLOCK), 
      } as ICustomizations, {
        onBidderDone: (bids) => {
          pushFirstAdViewed({ attributes })
        },
        onAuctionEnd: (winningBids) => {
          for (const bid of winningBids || []) {
            pushEvent({
              event: 'adWinningBid',
              label: bid.adUnitCode,
              action: bid.bidder,
              amount: bid.cpm,
              attributes 
            })
          }
        },
        onAdRenderSucceeded: (event) => {
          pushEvent({
            event: 'adRenderSucceeded',
            label: event.bid.adUnitCode,
            action: event.bid.bidder,
            amount: event.bid.cpm,
            attributes 
          })
        }
      })
      
      ads.initialize()
      ads.useAudigent();

      const shuffled = fixedShuffle(await loadContent([videoTagCache, cache].filter(v => v).join('|')))
        .filter((v) => !v.resolution || v.resolution === '16x9')
      
      if (keywords) {
        jaccardSort(shuffled, keywords)
      }

      const videosByUserId = shuffled.reduce((acc, v) => {
        if ('id' in v.user) {
          if (!acc[v.user.id]) acc[v.user.id] = []
          acc[v.user.id].push(v)
        }
        return acc
      }, {} as {[userId: string]: IVideo[]})
      
      const videosByListingId = shuffled.reduce((acc, v) => {
        v.listings.forEach(l => {
          if (!l.id) return
          if (!acc[l.id]) acc[l.id] = []
          acc[l.id].push(v)
        })
        return acc
      }, {} as {[listingId: string]: IVideo[]})

      const videos = listingId ? videosByListingId[listingId] || shuffled : 
                    userId ? videosByUserId[userId] || [] : 
                    shuffled

      if (!videos.length) return

      let currentIndex = 0
      this.currentMuted = true
      this.selectedMuted = false
      let currentListing: IListing|null = null
      let lastAdPlayed: Date|null = null

      element.innerHTML = `
      <div class="sellwild-wrapper">
        <div class="sellwild-tv-wrapper">
          <div class="video-blur-container">
            <video class="video-blur" playsinline muted data-selector="current-video-blur">
            </video>
          </div>
          <div class="sellwild-tv">
            <div class="sellwild-tv-left">
              <div>
                <h4 class="slide-up" data-selector="current-title"></h4>
                <ul data-selector="current-listings">
                </ul>
                ${adType === 'Prebid' || displayZids.length ? '' : `<div class="sellwild-next slide-up" style="--delay: 0.4s" data-selector="next-play">
                <video data-selector="next-video-blur" playsinline muted>
                </video>
                <div>
                  <p>Next on <img src="https://widget.sellwild.com/tv/logo_tv.png" alt="Sellwild Logo" /></p>
                  <video data-selector="next-video" playsinline muted>
                  </video>
                  <p data-selector="next-title"></p>
                  <div class="play">
                    <svg viewBox="0 0 490 490"><path stroke-width="30" d="M15.541,490V0l458.917,245.009L15.541,490z"/></svg>
                  </div>
                </div>
              </div>`}
              </div>
              <div>
              ${ads.useGoogleDisplay([300,250]) || ads.useBidstreamDisplay()}
              </div>
            </div>
            <div class="sellwild-tv-main-container">
              <div class="sellwild-tv-main-container-inner">
                <div class="sellwild-tv-main fade-in" data-selector="main">
                  ${videos.map((video, i) => `<div>
                  <video playsinline muted data-selector="main-video" data-index="${i}">
                  </video>
                  ${'type' in video.user && video.user.type === 'sponsored' ? `<${'href' in video ? `a href="${video.href}" data-event="clickRss" data-event-action="rss"  data-event-label="${video.title}" target="_blank" rel="nofollow sponsored noopener"` : 'div'} class="sellwild-tv-main-content">
                    ${title ? `<h6 class="shorts-listing-title">${title}</h6>` : ''}
                    ${video.title ? `<p class="shorts-listing-title">${video.title}</p>` : ''}
                    ${'href' in video ? `<p class="listing-link">${video.hrefText ? video.hrefText : 'Learn More >'}</p>` : ''}
                  </${'href' in video ? 'a' : 'div'}>` : ''}
                  </div>`).join('\n')}
                </div>
                <div class="sellwild-current-listing" data-selector="current-listing"></div>
                <div class="sellwild-current-loader" data-selector="current-loader"></div>
                <button class="scroll-to-next" data-selector="scroll-to-next">${scrollNextTitle} ${nextArrow()}</button>
                <div class="sellwild-controls-banner">${ads.useGoogleDisplay([320,50]) || ads.useMobileBanner()}</div>
                <div class="sellwild-controls">
                  <div class="progress">
                    <progress class="progress-bar" value="0" min="0" max="100" data-selector="progress-bar"></progress>
                    <div class="progress-ticks" data-selector="progress-ticks"></div>
                    <input class="progress-bar-seek" data-selector="progress-bar-seek" value="0" min="0" max="100" type="range" />
                  </div>
                  <div class="actions">
                    <div class="icon" data-selector="seek-prev">
                      ${nextIcon("rotate-180")}
                    </div>
                    <div class="icon" data-selector="play-pause" data-state="playing">
                      ${playIcon('height-30')}
                      ${pauseIcon()}
                    </div>
                    <div class="icon" data-selector="seek-next">
                      ${nextIcon()}
                    </div>
                    <div class="icon" data-selector="mute-unmute" data-state="muted">
                      ${muteIcon('height-30')}
                      ${unmuteIcon('height-30')}
                    </div>
                    <div class="timing" data-selector="timing"></div>
                  ${true ? '' : `<div class="icon" data-selector="fullscreen" data-state="not-fullscreen">
                      ${fullscreenIcon()}
                      ${exitFullscreenIcon()}
                    </div>`}
                  </div>
                </div>
                <div class="tv-action-buttons">
                  <button class="like" data-selector="like">${heartIconOutlined()}</button>
                  ${window.navigator && 'share' in window.navigator ? `<button class="share" data-selector="share">${shareIcon()}</button>` : ''}
                  </div>
                <div data-selector="ad"></div>
                <button data-selector="close" class="close">×</button>
              </div>
            </div>
            <div class="sellwild-tv-right">
              <div style="margin-bottom: auto;">
                <div class="sellwild-card" style="border-radius: var(--spacing);" data-selector="current-user"></div>
                ${displayZids.length ? '' : `<div class="sellwild-card" style="background-color: #ededed; flex: 1">
                  <div class="sellwild-search slide-up">
                    <input placeholder="Search Marketplace" data-selector="search-input" />
                    <button data-selector="search-button">
                      <svg viewBox="0 0 490.4 490.4">
                        <path d="M484.1,454.796l-110.5-110.6c29.8-36.3,47.6-82.8,47.6-133.4c0-116.3-94.3-210.6-210.6-210.6S0,94.496,0,210.796 s94.3,210.6,210.6,210.6c50.8,0,97.4-18,133.8-48l110.5,110.5c12.9,11.8,25,4.2,29.2,0C492.5,475.596,492.5,463.096,484.1,454.796z M41.1,210.796c0-93.6,75.9-169.5,169.5-169.5s169.6,75.9,169.6,169.5s-75.9,169.5-169.5,169.5S41.1,304.396,41.1,210.796z"/>
                      </svg>
                    </button>
                  </div>
                  <div class="sellwild-categories">
                    <a class="slide-up" style="--delay: 0.1s"  data-event-action="category-fashion" href="${sellwildUrl(baseUrl, '/browse/fashion', code)}" ${targetBlank ? `target="_blank"` : ''} rel="nofollow sponsored noopener">
                      <img src="https://widget.sellwild.com/tv/fashion.png" alt="Fashion" />
                      <p>Fashion</p>
                    </a>
                    <a class="slide-up" style="--delay: 0.2s"  data-event-action="category-vehicles" href="${sellwildUrl(baseUrl, '/browse/vehicles', code)}" ${targetBlank ? `target="_blank"` : ''} rel="nofollow sponsored noopener">
                      <img src="https://widget.sellwild.com/tv/vehicles.png" alt="Vehicles" />
                      <p>Vehicles</p>
                    </a>
                    <a class="slide-up" style="--delay: 0.3s"  data-event-action="category-electronics" href="${sellwildUrl(baseUrl, '/browse/electronics', code)}" ${targetBlank ? `target="_blank"` : ''} rel="nofollow sponsored noopener">
                      <img src="https://widget.sellwild.com/tv/electronics.png" alt="Electronics" />
                      <p>Electronics</p>
                    </a>
                  </div>
                  <div class="slide-up" style="--delay: 0.4s">
                    <a class="sellwild-cta" data-event-action="mailto" href="mailto:support@sellwild.com?subject=[INSERT SOCIAL MEDIA LINKS BEOFE EMAILING] I’d like to get paid for my product review videos&body=My YouTube URL and/or other Social media account(s):" ${targetBlank ? `target="_blank"` : ''} rel="nofollow sponsored noopener">
                      <p>Have items to review?</p>
                      <img src="https://widget.sellwild.com/tv/logo_tv.png" alt="Sellwild Logo" />
                      <p>will pay for your videos!</p>
                    </a>
                  </div>
                </div>`}
              </div>
              <div>
                ${ads.useGoogleDisplay([300,250]) || ads.useBidstreamDisplay()}
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>${css}</style>
      `

      const stylesheet = document.createElement('style')
      stylesheet.innerHTML = styles
      element.appendChild(stylesheet)

      ads.appendScripts(document.body).then(v => {
        if (v && v.blocked) {
          pushEvent({ event: 'adsGeoBlocked', action: v.type, label: v.value, attributes })
        }
      });
      const currentTitle = element.querySelector('[data-selector=current-title]') as Element
      const currentListings = element.querySelector('[data-selector=current-listings]') as Element
      const currentVideoBlur = element.querySelector('[data-selector=current-video-blur]') as HTMLVideoElement
      const main = element.querySelector('[data-selector=main]') as Element
      const mainVideos = Array.from(element.querySelectorAll('[data-selector=main-video]')) as (HTMLVideoElement & { hls?: any })[]
      const currentUser = element.querySelector('[data-selector=current-user]') as Element
      const currentListingElement = element.querySelector('[data-selector=current-listing]') as Element
      const currentLoader = element.querySelector('[data-selector=current-loader]') as Element

      const nextVideoBlur = element.querySelector('[data-selector=next-video-blur]') as (HTMLVideoElement | null)
      const nextVideo = element.querySelector('[data-selector=next-video]') as (HTMLVideoElement | null)
      const nextTitle = element.querySelector('[data-selector=next-title]')
      const nextPlayBtn = element.querySelector('[data-selector=next-play]')

      const searchInput = element.querySelector('[data-selector=search-input]') as HTMLInputElement
      const searchButton = element.querySelector('[data-selector=search-button]') as Element

      const progressBar = element.querySelector('[data-selector=progress-bar]') as HTMLProgressElement
      const progressSeek = element.querySelector('[data-selector=progress-bar-seek]') as HTMLInputElement
      const progressTicks = element.querySelector('[data-selector=progress-ticks]') as HTMLElement

      const scrollToNextBtn = element.querySelector('[data-selector=scroll-to-next]') as HTMLElement
      const seekPrev = element.querySelector('[data-selector=seek-prev]') as HTMLElement
      const playPause = element.querySelector('[data-selector=play-pause]') as HTMLElement
      const seekNext = element.querySelector('[data-selector=seek-next]') as HTMLElement
      const muteUnmute = element.querySelector('[data-selector=mute-unmute]') as HTMLElement
      const timing = element.querySelector('[data-selector=timing]') as HTMLElement
      const fullscreen = element.querySelector('[data-selector=fullscreen]') as HTMLElement
      const adContainer = element.querySelector('[data-selector=ad]') as HTMLElement

      const likeButton = element.querySelector('[data-selector=like]') as HTMLElement
      const shareButton = element.querySelector('[data-selector=share]') as HTMLElement
 
      function getCurrentId() {
        const video = videos[currentIndex];
        return video && (video.id || video.videoId || video.title);
      }
    
      function getCurrentTitle() {
        const video = videos[currentIndex];
        return video && video.title;
      }

      const likeProvider = makeLikeProvider({
        likeButton,
        getCurrentVideo: () => videos[currentIndex],
        onLiked: (id) => pushEvent({ event: 'like', label: getCurrentTitle(), attributes: { videoId: id, ...attributes } })
      })

      shareButton && shareButton.addEventListener('click', () => {
        try {
          const id = getCurrentId()
          const title = getCurrentTitle()
          if (id && title) {
            if (window.navigator && 'share' in window.navigator) {
              (window.navigator as any).share({
               title: title,
               url: `https://sellwild.com/tv?id=${id}`
             })
            }
          }
        } catch {}
      })

      const renderSellwildVideos = (unmuted?: boolean) => {
        this.currentMuted = !unmuted
        if (!this.selectedMuted && unmuted) {
          for (const video of mainVideos) {
            video.muted = !unmuted
          }
        }

        renderContent()
        playCurrentVideo(currentIndex, this.currentMuted)
        likeProvider.updateCurrentLikeState()
      }

      document.addEventListener('visibilitychange', (ev) => {
        if (document.hidden) {
          // PAUSE ALL
          pauseAllVideo()
        } else {
          // RESUME
        }
      });

      function pauseAllVideo () {
        const ad = adContainer.querySelector('sellwild-video') as (HTMLElement & { adsManager: any })
        if (ad && ad.adsManager) {
          ad.adsManager.pause()
        }
        
        for (const video of mainVideos) {
          video.muted = true
        }
      }

      this.mainVideos = mainVideos

      function updatePlayState (video: HTMLVideoElement) {
        playPause.setAttribute('data-state', video.paused ? 'paused' : 'playing')
      }
      
      function updateVolume (video: HTMLVideoElement) {
        muteUnmute.setAttribute('data-state', video.muted || video.volume === 0 ? 'muted' : 'unmuted')
      }

      scrollToNextBtn.addEventListener('click', (ev) => {
        showCurrentVideo(currentIndex + 1)
      })

      currentListings.addEventListener('click', (ev) => {
        if (ev.target && ev.target instanceof HTMLElement) {
          const closest = ev.target.closest(`[data-selector=video-list-item]`)
          if (closest) {
            const index = Number(closest.getAttribute('data-index'))
            if (!isNaN(index)) {
              showCurrentVideo(index)
            }
          }
        }
      })

      element.play = () => {
        const ad = adContainer.querySelector('sellwild-video') as (HTMLElement & { adsManager: any })
        if (ad && ad.adsManager) {
          ad.adsManager.resume()
        } else {
          const i = currentIndex % videos.length
          const video = mainVideos[i]
          video.play()
          currentVideoBlur.play()
        }
      }

      element.pause = () => {
        const i = currentIndex % videos.length
        const video = mainVideos[i]
        video.pause()
        currentVideoBlur.pause()

        const ad = adContainer.querySelector('sellwild-video') as (HTMLElement & { adsManager: any })
        if (ad && ad.adsManager) {
          ad.adsManager.pause()
        }
      }

      playPause.addEventListener('click', (ev) => {
        ev.stopPropagation()
        const i = currentIndex % videos.length
        const video = mainVideos[i]
        if (video.paused) {
          video.play()
          currentVideoBlur.play()
          element.manualPause = false
        } else {
          video.pause()
          currentVideoBlur.pause()
          element.manualPause = true
        }
      })

      const iheart = iheartPlayer({
        onPlay: () => {
          this.selectedMuted = true
          for (const video of mainVideos) {
            video.muted = true
          }
        }
      })

      muteUnmute.addEventListener('click', (ev) => {
        ev.stopPropagation()
        const i = currentIndex % videos.length
        const video = mainVideos[i]
        this.currentMuted = !video.muted
        this.selectedMuted = !video.muted

        for (const video of mainVideos) {
          video.muted = !video.muted
        }

        if (video.muted) {
          iheart.claimAudio()
        } else {
          iheart.releaseAudio()
        }
      })

      seekNext.addEventListener('click', (ev) => {
        ev.stopPropagation()
        const i = currentIndex % videos.length
        const video = mainVideos[i]
        const listingIndex = videos[i].listings.findIndex((listing) => !!(listing.startTimestamp && listing.startTimestamp > video.currentTime))
        const nextListing = videos[i].listings[listingIndex]
        if (nextListing && typeof nextListing.startTimestamp === 'number') {
          video.currentTime = nextListing.startTimestamp
          if (mainVideos[i].duration) {
            const value = Math.floor(nextListing.startTimestamp / mainVideos[i].duration * 100)
            progressBar.value = value
            progressSeek.value = String(value)
          }
        } else {
          currentIndex += 1
          showCurrentVideo(currentIndex)
        }
        if (!this.selectedMuted) {
          this.currentMuted = false
          for (const video of mainVideos) {
            video.muted = false
          }
        }
      })

      seekPrev.addEventListener('click', (ev) => {
        ev.stopPropagation()
        const i = currentIndex % videos.length
        const video = mainVideos[i]
        const listingIndex = findLastIndex(videos[i].listings, (listing) => !!(listing.startTimestamp && listing.startTimestamp <= video.currentTime))
        const prevListing = videos[i].listings[listingIndex - 1]
        if (prevListing && typeof prevListing.startTimestamp === 'number') {
          video.currentTime = prevListing.startTimestamp
          if (mainVideos[i].duration) {
            const value = Math.floor(prevListing.startTimestamp / mainVideos[i].duration * 100)
            progressBar.value = value
            progressSeek.value = String(value)
          }
        } else {
          currentIndex -= 1
          if (currentIndex < 0) {
            currentIndex = videos.length + currentIndex
          }
          showCurrentVideo(currentIndex)
        }
        if (!this.selectedMuted) {
          this.currentMuted = false
          for (const video of mainVideos) {
            video.muted = false
          }
        }
      })

      progressSeek.addEventListener('click', (ev) => {
        ev.stopPropagation()
        const i = currentIndex % videos.length
        const video = mainVideos[i]
        if (!this.selectedMuted) {
          this.currentMuted = false
          for (const video of mainVideos) {
            video.muted = false
          }
        }
      })

      progressSeek.addEventListener('input', (ev) => {
        ev.stopPropagation()
        const i = currentIndex % videos.length
        const video = mainVideos[i]
        video.currentTime = Number(progressSeek.value) / 100 * video.duration
      });

      if (fullscreen) {
        fullscreen.addEventListener('click', () => {
          if (document.fullscreenEnabled) {
            if (document.fullscreenElement) {
              document.exitFullscreen()
            } else {
              const mainParent = main.parentElement
              if (!mainParent) return
  
              mainParent.requestFullscreen()
              .catch((err) => {
                console.log('Fullscreen Error', err)
              })
            }
          } else {
            const videoElement: any = mainVideos[currentIndex % videos.length]
            enterFullscreen(videoElement)
          }
        })
      }

      document.addEventListener("fullscreenchange", (event) => {
        if (document.fullscreenElement) {
          fullscreen.setAttribute('data-state', 'is-fullscreen')
        } else {
          fullscreen.setAttribute('data-state', 'not-fullscreen')
        }
      });

      function enterFullscreen (videoElement: any) {
        if (videoElement.enterFullScreen) {
          videoElement.enterFullScreen()
        } else if (videoElement.webkitEnterFullScreen) {
          videoElement.webkitEnterFullScreen()
        } else if (videoElement.mozEnterFullScreen) {
          videoElement.mozEnterFullScreen()
        } else if (videoElement.msEnterFullScreen) {
          videoElement.msEnterFullScreen()
        }
      }
      
      function exitFullscreen (videoElement: any) {
        if (videoElement.exitFullScreen) {
          videoElement.exitFullScreen()
        } else if (videoElement.webkitExitFullScreen) {
          videoElement.webkitExitFullScreen()
        } else if (videoElement.mozExitFullScreen) {
          videoElement.mozExitFullScreen()
        } else if (videoElement.msExitFullScreen) {
          videoElement.msExitFullScreen()
        }
      }

      for (const i in mainVideos) {
        const video = mainVideos[i]
        const listings = videos[i].listings

        // if (typeof videos[i].volume === 'number') {
        //   video.volume = videos[i].volume
        // }

        video.addEventListener('enterpictureinpicture', () => {
          if (element.parentElement) {
            element.parentElement.classList.remove('corner')
          }
        })
        
        video.addEventListener('click', () => {
          if (video.paused) {
            video.muted = false
            video.play()
            currentVideoBlur.play()
          } else {
            video.pause()
            currentVideoBlur.pause()
          }
        })

        video.addEventListener('play', () => {
          if (currentIndex === Number(i)) {
            updatePlayState(video)
          }
        })
        video.addEventListener('pause', () => {
          if (currentIndex === Number(i)) {
            updatePlayState(video)
          }
        })
        video.addEventListener('volumechange', () => {
          if (currentIndex === Number(i)) {
            updateVolume(video)
          }
        });

        video.addEventListener('ended', () => {
          const endedVideo: any = mainVideos[currentIndex % videos.length]
          
          currentIndex++
          showCurrentVideo(currentIndex)
          
          const isFullscreen = endedVideo.webkitDisplayingFullscreen || endedVideo.moxDisplayingFullscreen || endedVideo.msDisplayingFullscreen
          if (!document.fullscreenEnabled && isFullscreen) {
            const video = mainVideos[currentIndex % videos.length]
            exitFullscreen(endedVideo)
            // setTimeout(() => {
            //   enterFullscreen(video)
            // }, 1000)
          }
        })

        video.addEventListener('timeupdate', () => {
          if (typeof video.currentTime === 'number' && video.duration) {
            updateCurrentListing(listings, video.currentTime, video.duration, i)
          }
        })

        video.addEventListener('error', (error) => {
          console.log('Video error', error)
          video.hls = null
        })

        // video.addEventListener('loadstart', () => {
        //   console.log('VIDEO LOAD START', video)
        // })

        // video.addEventListener('loadeddata', () => {
        //   console.log('VIDEO LOADED DATA', video)
        // })

        video.addEventListener('waiting', () => {
          if (currentIndex === Number(i)) {
            showLoader()
          }
        })
        
        video.addEventListener('playing', () => {
          if (currentIndex === Number(i)) {
            removeLoader()
          }
        })
      }

      function showLoader () {
        currentLoader.classList.add('show')
      }
      
      function removeLoader () {
        currentLoader.classList.remove('show')
      }

      function updateCurrentListing (listings: IListing[], currentTime: number, duration: number, i: number|string) {
        const progressValue = Math.floor(currentTime / duration * 100)
        progressBar.value = progressValue
        progressSeek.value = String(progressValue)

        for (const j in listings) {
          const listing = listings[j]
          if (
            typeof listing.startTimestamp === 'number' && 
            typeof listing.endTimestamp === 'number' && 
            listing.startTimestamp <= currentTime && 
            listing.endTimestamp > currentTime
          ) {
            if (currentIndex % videos.length === Number(i) && currentListing !== listing) {
              currentListing = listing
              currentListingElement.innerHTML = makeListingSection(listing, baseUrl, code, targetBlank)
              setTimeout(() => {
                scrollToListing(Number(j))
              }, 300)
            }
            return
          }
        }
        currentListing = null
        currentListingElement.innerHTML = ''
      }

      function renderComingUpOn (currentIndex: number) {
        const current = videos[currentIndex % videos.length]
        currentTitle.innerHTML = 'Coming up next'
        if ('type' in current.user) {
          currentListings.innerHTML = makeOtherVideos(videos, currentIndex)
          if (currentListings.parentElement) {
            currentListings.parentElement.append(currentListings)
          }
        } else {
          currentListings.innerHTML = makeListings(current.listings, baseUrl, code, targetBlank)
        }
        currentUser.innerHTML = makeUserSection(current.user, baseUrl, code, targetBlank)
        updateSources(currentVideoBlur, current.sources)

        if (nextTitle) {
          nextTitle.innerHTML = makeNextTitle(current)
        }
        if (nextVideoBlur) {
          updateSources(nextVideoBlur, current.sources, 1)
        }
        if (nextVideo) {
          updateSources(nextVideo, current.sources)
        }
        nextPlayBtn && nextPlayBtn.classList.add('coming-up')
      }

      function renderContent () {
        const current = videos[currentIndex % videos.length]
        const next = videos[(currentIndex + 1) % videos.length]

        currentTitle.innerHTML = makeTitle(current)
        if ('type' in current.user) {
          currentListings.innerHTML = makeOtherVideos(videos, currentIndex)
          if (currentListings.parentElement) {
            currentListings.parentElement.append(currentListings)
          }
        } else {
          currentListings.innerHTML = makeListings(current.listings, baseUrl, code, targetBlank)
        }
        currentUser.innerHTML = makeUserSection(current.user, baseUrl, code, targetBlank)
        updateSources(currentVideoBlur, current.sources)
        
        if (nextTitle) {
          nextTitle.innerHTML = makeNextTitle(next)
        }
        if (nextVideoBlur) {
          updateSources(nextVideoBlur, next.sources, 1)
        }
        if (nextVideo) {
          updateSources(nextVideo, next.sources)
        }
        updateSources(mainVideos[currentIndex], current.sources)
        updateCurrentListing(current.listings, 0, 120, currentIndex)
        nextPlayBtn && nextPlayBtn.classList.remove('coming-up')
        
        progressTicks.innerHTML = ''
        const videoElement = mainVideos[currentIndex % videos.length]
        if (!isNaN(videoElement.duration)) {
          renderTicks()
        } else {
          videoElement.onloadedmetadata = renderTicks
        }

        function renderTicks () {
          if (mainVideos[currentIndex % videos.length] === videoElement) {
            progressTicks.innerHTML = ''
            const current = videos[currentIndex % videos.length]
            for (const listing of current.listings) {
              if (listing.startTimestamp) {
                const element = document.createElement('div')
                const left = `${Math.floor(listing.startTimestamp / videoElement.duration * 100)}%`
                element.style.left = left
                progressTicks.appendChild(element)
              }
            }
          }
        }
      }

      function scrollToListing (i: number) {
        const element = currentListings.querySelector(`[data-index=listing-${i}]`)
        if (element) {
          const containerRect = currentListings.getBoundingClientRect()
          const rect = element.getBoundingClientRect()
          const padding = 16
          currentListings.scrollTo(0, rect.top - containerRect.top + currentListings.scrollTop - padding)
        }
      }

      function showCurrentVideo (currentIndex: number) {
        const video = mainVideos[currentIndex % videos.length]
        const mainRect = main.getBoundingClientRect()
        const rect = video.getBoundingClientRect()
        main.scrollTo(0, rect.top - mainRect.top + main.scrollTop)
        // video.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }

      function playCurrentVideo (currentIndex: number, muted: boolean) {
        const sellwildShorts = Array.from(document.querySelectorAll('sellwild-shorts')) as (HTMLElement & { fullscreenOpen: boolean })[]
        const sellwildShortsOpen = sellwildShorts.some(sellwildShort => sellwildShort.fullscreenOpen)
        mainVideos.forEach((video, i) => {
          if (!sellwildShortsOpen && i === currentIndex % videos.length) {
            currentVideoBlur.load()
            video.load()
            currentVideoBlur.play().catch((err) => {
              console.log(err)
            })
            video.play().catch((err) => {
              console.log(err)
            })
            pushEvent({ event: 'play', label: videos[i].title, attributes })
          } else {
            video.pause()
          }
        })
        if (currentIndex === videos.length - 1) {
          scrollToNextBtn.classList.add('hidden')
        } else {
          scrollToNextBtn.classList.remove('hidden')
        }
      }

      renderComingUpOn(currentIndex)

      const renderAdvertisement = debounce(() => {
        if (iu && adUnit && !adContainer.innerHTML && canPlayAdvertisement()) {
          lastAdPlayed = new Date()
          
          currentVideoBlur.pause()
          mainVideos.forEach((video, i) => {
            video.pause()
          })

          const element = document.createElement('sellwild-video') as SellwildVideoElement & { 
            renderSellwildVideos: (unmuted?: boolean) => void
            pushEvent: (event: string) => void
          }
          element.pushEvent = (event: string) => {
            pushEvent({ event, attributes })
          }
          element.onStarted = () => {
            pushFirstAdViewed({ attributes })
            element.pushEvent('adStarted');
          }
          const src = videos[currentIndex].sources && videos[currentIndex].sources[0] && videos[currentIndex].sources[0].src || 'https://github.com/esc0rtd3w/blank-intro-videos/blob/master/blank.mp4?raw=true'
          element.renderSellwildVideos = renderSellwildVideos
          element.setAttribute('iu', iu || '')
          element.setAttribute('ad-unit', adUnit || '')
          element.setAttribute('bids', JSON.stringify(ads.useBids([1, 1])))
          element.setAttribute('src', src)
          element.onCompleted = () => {
            element.pushEvent('adCompleted');
            element.renderSellwildVideos();
            element.remove();
          }
          element.onAllAdsCompleted = () => {
            element.pushEvent('allAdsCompleted');
            element.renderSellwildVideos();
            element.remove();
          }
          element.onSkipped = () => {
            element.pushEvent('adSkipped');
            element.renderSellwildVideos(true);
            element.remove();
          }
          element.onAdError = () => {
            element.pushEvent('adError');
            element.renderSellwildVideos();
            element.remove();
          }
          element.onNoBids = () => {
            element.pushEvent('adNoBids');
            element.renderSellwildVideos();
            element.remove()
          }
          
          adContainer.appendChild(element)

          const shortsAds = Array.from(document.querySelectorAll('sellwild-shorts sellwild-video')) as (HTMLElement & { adsManager: any })[]
          for (const shortsAd of shortsAds) {
            if (shortsAd && shortsAd.adsManager) {
              shortsAd.adsManager.pause()
            }
          }
        } else {
          renderSellwildVideos(false)
        }
      }, 200)
      
      if (float) {
        this.observeVisibility(element.firstElementChild as SellwildTvElement, floatBehavior, once(renderAdvertisement))
      } else {
        renderAdvertisement()
      }

      // document.addEventListener('click', () => {
      //   currentMuted = false
      //   for (const video of mainVideos) {
      //     video.muted = false
      //   }
      // })

      if (nextPlayBtn) {
        nextPlayBtn.addEventListener('click', () => {
          showCurrentVideo(currentIndex + 1)
        })
      }

      const scrollHandler = () => {
        const mainRect = main.getBoundingClientRect()
        
        const current = mainVideos.reduce((acc, video, i) => {
          const rect = video.getBoundingClientRect();
          const videoHeight = video.offsetHeight;
          const threshold = videoHeight / 2;

          if (mainRect.top > rect.top - threshold) {
            return i
          }

          return acc
        }, 0);


        if (currentIndex !== current) {
          currentIndex = current
          currentListing = null
          // renderContent()
          renderAdvertisement()
        }
      }

      main.addEventListener('scroll', scrollHandler)

      function executeSellwildSearch () {
        const q = searchInput.value.trim()
        window.open(sellwildUrl(baseUrl, `/search?q=${q}`))
      }

      const SECOND = 1000
      function canPlayAdvertisement () {
        if (!lastAdPlayed) return true
        if (lastAdPlayed.valueOf() < (Date.now() - 75 * SECOND)) return true
        return false
      }

      searchInput.addEventListener('keydown', (ev) => {
        if (ev.key === 'Enter') {
          executeSellwildSearch()
        }
      })

      searchButton.addEventListener('click', () => {
        executeSellwildSearch()
      })
    },
    elementRemoved (el: HTMLElement) {
      const element = el as SellwildTvElement
      elements.delete(element.id)
    }
  }
}

function makeTitle (current: IVideo) {
  if ('type' in current.user && current.user.type === 'sponsored') {
    return 'Coming up next'
  }
  return `${current.listings.length} Listing${current.listings.length !== 1 ? 's' : ''} in this video`
}

function makeListing (listing: IListing, i: number, baseUrl: string, code?: string|null, targetBlank?: boolean) {
  if (!listing.id || !listing.title) return ''
  return `
  <li class="slide-up" style="--delay: ${(i * 0.1).toFixed(1)}s" data-index="listing-${i}">
    <a href="${sellwildUrl(baseUrl, `/product/${listing.id}/${listing.title.toLowerCase().replace(/ /g, '-')}`, code)}" ${targetBlank ? `target="_blank"` : ''} data-event-action="product" data-event-label="${listing.title}" rel="nofollow sponsored noopener">
      <img src="${listing.src}" alt="${listing.title}" class="tv-listing-img" />
      <div class="listing-details">
        <div class="listing-details-main"><p class="tv-listing-title">${listing.title}</p></div>
        <div class="listing-details-sub">
          <span class="tv-listing-price">$${listing.price}</span>
          <span class="listing-link">Learn More ></span>
        </div>
      </div>
    </a>
  </li>`
}

function makeVideo (video: IVideo, i: number) {
  return `
  <li class="slide-up" style="--delay: ${(i * 0.1).toFixed(1)}s" data-index="${i}" data-selector="video-list-item">
    <a>
      <img src="${(video.poster || '').replace('1.jpg', '0.jpg')}" alt="${video.title}" class="tv-listing-img" />
      <div class="listing-details">
        <div class="listing-details-main"><p class="tv-listing-title">${video.title}</p></div>
      </div>
    </a>
  </li>`
}

function makeListings (listings: IListing[], baseUrl: string, code?: string|null, targetBlank?: boolean) {
  return listings.map((listing, i) => makeListing(listing, i, baseUrl, code, targetBlank)).join('\n')
}

function makeOtherVideos (videos: IVideo[], currentIndex: number) {
  const sections = videos.map((video, i) => i !== currentIndex ? makeVideo(video, i) : '')
  return sections.slice(currentIndex + 2).concat(sections.slice(0, currentIndex + 2)).join('\n')
}

function makeSources (sources: ISource[], frame='') {
  return sources.map((source) => `<source src="${source.src}${frame}" type="${source.type}">`).join('\n')
}

function makeListingSection (listing: IListing, baseUrl: string, code?: string|null, targetBlank?: boolean) {
  if (!listing.id || !listing.title) return ''
  return `
    <a href="${sellwildUrl(baseUrl, `/product/${listing.id}/${listing.title.toLowerCase().replace(/ /g, '-')}`, code)}" ${targetBlank ? `target="_blank"` : ''} data-event-action="product" data-event-label="${listing.title}" rel="nofollow sponsored noopener">
      <img src="${listing.src}" alt="${listing.title}" class=tv-listing-img slide-up" />
      <div class="listing-details slide-up" style="--delay: 0.1s">
        <div class="listing-details-main"><p class="tv-listing-title">${listing.title}</p></div>
        <div class="listing-details-sub">
          <span class="tv-listing-price">$${listing.price}</span>
          <span class="listing-link">Learn More ></span>
        </div>
      </div>
    </a>
  `
}

function updateSources (element: HTMLVideoElement & { hls?: any }, sources: ISource[], frame = 0) {

  const Hls = (window as any)['Hls']
  const source = sources[0]
  
  if (source.type === 'application/x-mpegURL' && Hls.isSupported()) {
    if (element.hls) {
      element.hls.loadSource(source.src);
      element.hls.attachMedia(element);
      return
    }
    const hls = new Hls()
    hls.loadSource(source.src);
    hls.attachMedia(element);
    element.currentTime = frame
    element.hls = hls
  } else {
    const sourceElements = Array.from(element.querySelectorAll('source'))
  
    for (const i in sources) {
      const source = sources[i]
      const sourceElement = sourceElements[i]
      const src = `${source.src}${frame ? `#t=${frame}` : ''}`
      if (sourceElement) {
        sourceElement.setAttribute('src', src)
        sourceElement.setAttribute('type', source.type)
      } else {
        const newElement = document.createElement('source')
        newElement.src = src
        newElement.setAttribute('type', source.type)
        element.appendChild(newElement)
      }
    }
    element.load()
  }  
}

function makeUserSection (user: IUser, baseUrl: string, code?: string | null, targetBlank?: boolean) {
  if (!('id' in user) || !('name' in user)) return ''
  return `
    <div class="sellwild-user slide-up">
      <a class="sellwild-avatar" href="${user.link || sellwildUrl(baseUrl, `/s/${user.id}`, code)}" ${targetBlank ? `target="_blank"` : ''}  data-event-action="user" data-event-label="${user.id}" rel="nofollow sponsored noopener">
        <img src="${user.avatar}" alt="${user.username}" />
        <div class="checkmark">
          <svg width="7" height="6" viewBox="0 0 7 6" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.38053 5.20112C2.27489 5.20112 2.16935 5.16104 2.08898 5.08017L0.301514 3.2927C0.140381 3.13147 0.140381 2.87023 0.301514 2.7091C0.462646 2.54796 0.723883 2.54796 0.885117 2.7091L2.38103 4.20511L5.66462 0.921631C5.82575 0.760498 6.08699 0.760498 6.24812 0.921631C6.40925 1.08276 6.40925 1.344 6.24812 1.50513L2.67309 5.08017C2.59171 5.16104 2.48617 5.20112 2.38053 5.20112Z"/>
          </svg>
        </div>
      </a>
      <a class="sellwild-user-info" href="${user.link || sellwildUrl(baseUrl, `/s/${user.id}`, code)}" ${targetBlank ? `target="_blank"` : ''} data-event-action="user" data-event-label="${user.id}" rel="nofollow sponsored noopener">
        <h4>${user.name}</h4>
        <p>${user.subtitle}</p>
        <button>Visit My Store!</button>
      </a>
    </div>
  `
}

function makeNextTitle (next: { title: string; user: IUser }) {
  if ('name' in next.user) return `${next.user.name}'s ${next.title || ''}`
  return next.title || ''
}

async function loadDependencies() {
  await Promise.all([
    loadScript('https://cdnjs.cloudflare.com/ajax/libs/hls.js/0.5.14/hls.min.js')
  ]);
}

const sellwildTvCtrl = sellwildTvController();
sellwildTvCtrl.initialize();
observeCustomElement(
  "sellwild-tv",
  sellwildTvCtrl.elementAdded.bind(sellwildTvCtrl),
  sellwildTvCtrl.elementRemoved.bind(sellwildTvCtrl)
);

function findLastIndex<V = unknown>(arr: V[], callback: (v: V, i: number, vs: V[]) => boolean) {
  for (let i = arr.length - 1; i >= 0; i--) {
    if (callback(arr[i], i, arr)) return i;
  }
  return -1;
}

function once (fn: () => void) {
  let wasCalled = false
  return () => {
    if (!wasCalled) {
      wasCalled = true
      fn()
    }
  }
}

function debounce(fn: (...args: any[]) => any, n = 0) {
  let timerId: any
  return (...args: any[]) => {
    clearTimeout(timerId)
    timerId = setTimeout(() => {
      fn(...args)
    }, n)
  }
}


async function loadContent (value: string | null): Promise<IVideo[]> {
  if (!value) return []
  if (value.indexOf('http') === 0) {
    const urls = value.split('|').map(v => v.trim()).filter(v => v)

    const contents = await Promise.all(
      urls.map((url) => fetch(url).then(appendViewerHeaders))
    )

    const map = new Map<string, IVideo>()

    for (const content of contents) {
      for (const video of content) {
        map.set(video.id || video.videoId, video)
      }
    }

    return Array.from(map).map(([_, value]) => value)
  }
  try {
    return JSON.parse(value)
  } catch (err) {
    return []
  }
}

function parseNums (value = '') {
  return String(value || '').split(',').map(v => Number(v.trim()) || v).filter(v => v)
}

function sellwildUrl (baseUrl: string, path: string, partnerCode?: string | null) {
  if (partnerCode) return `${baseUrl}${path}${path.includes('?') ? '&' : '?'}p=${partnerCode}&utm_source=${partnerCode}&utm_content=tv`
  return `${baseUrl}${path}`
}

const styles = `
@font-face {
  font-family: 'Myriad Pro';
  font-style: normal;
  font-weight: normal;
  src: local('Myriad Pro'), url('/fonts/myriadpro-regular.woff') format('woff');
}

@font-face {
  font-family: 'Butler';
  font-style: normal;
  font-weight: normal;
  src: local('Butler'), url('/fonts/Butler_Bold.woff') format('woff');
}

/* latin-ext */
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url('/fonts/S6u9w4BMUTPHh7USSwaPGQ3q5d0N7w.woff2') format('woff2');
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url('/fonts/S6u9w4BMUTPHh7USSwiPGQ3q5d0.woff2') format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

/* latin-ext */
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('/fonts/S6uyw4BMUTPHjxAwXiWtFCfQ7A.woff2') format('woff2');
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('/fonts/S6uyw4BMUTPHjx4wXiWtFCc.woff2') format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
sellwild-tv {
  display: block;
  font-family: Lato;
  font-weight: 400;
  /* max-width: 930px; */
  height: 100%;

  --spacing: 8px;
  --white: #fff;
  --black: #000;
  --blue: #6a8cbf;
}

.sellwild-tv-wrapper {
  /* padding-top: 50%; */
  background-color: rgb(170, 170, 170);
  position: relative;
  height: 465px;
  width: 100%;
  max-height: 100%;
}

.sellwild-tv-wrapper .video-blur-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.sellwild-tv-wrapper .video-blur {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(50px);
}

.sellwild-tv {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
}

.sellwild-tv-main-container {
  flex: 2;
  position: relative;
}

.sellwild-tv-main-container-inner {
  position: relative;
  height: 100%;
  background-color: rgba(125, 125, 125, 0.5);
}

.sellwild-tv-main {
  height: 100%;
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
  scroll-snap-stop: always;
  overflow-x: hidden;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  scroll-behavior: smooth;
}

.sellwild-tv-main::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome, Safari and Opera */
}

.sellwild-tv-main>div {
  position: relative;
  height: 100%;
}

.sellwild-tv-main .sellwild-tv-main-content {
  position: absolute;
  bottom: 0;
  left: 0;
  padding-bottom: 60px;
  text-decoration: none;
  padding-left: var(--spacing);
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 60px, rgba(0, 0, 0, 0));
  width: 100%;
}

.sellwild-tv-main .shorts-listing-title {
  line-height: 1.2em;
  height: 2.4em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  color: var(--white);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 0;
}

.sellwild-tv-main h6.shorts-listing-title {
  height: 1.2em;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 8px;
}

.sellwild-tv .sellwild-tv-main .listing-link {
  white-space: nowrap;
  color: var(--white);
  font-size: 14px;
  text-decoration: underline;
  text-align: left;
}

.sellwild-tv-main video {
  position: relative;
  scroll-snap-align: start;
  object-fit: contain;
  display: block;
  height: 100%;
  width: 100%;
}

.sellwild-wrapper.corner .sellwild-tv-main video {
  object-fit: cover;
}

.sellwild-tv-left,
.sellwild-tv-right {
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;
  overflow: hidden;
  min-width: 310px;
}

.sellwild-tv-left:before,
.sellwild-tv-right:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(125, 125, 125, 0.5);
}

.sellwild-tv-left>div:first-child {
  position: relative;
  padding: calc(var(--spacing) * 3) calc(var(--spacing) * 4);
  padding-bottom: var(--spacing);
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sellwild-tv-right>div:first-child {
  position: relative;
  padding: calc(var(--spacing) * 1.5) calc(var(--spacing) * 2);
  padding-bottom: var(--spacing);
  display: flex;
  /* flex: 1; */
  gap: calc(var(--spacing) * 2);
  flex-direction: column;
  overflow: hidden;
}

.sellwild-tv-left>div:nth-child(2),
.sellwild-tv-right>div:nth-child(2),
.sellwild-tv-left ins,
.sellwild-tv-right ins {
  position: relative;
  margin: 0 auto;
  margin-bottom: var(--spacing)!important;
}

.sellwild-tv-left h4 {
  color: var(--white);
  font-size: 22px;
  font-family: "Butler", serif;
  font-weight: 400;
  align-self: flex-start;
  padding-bottom: calc(var(--spacing) / 2);
  border-bottom: 2px solid var(--black);
  margin: 0;
  /* margin-bottom: calc(var(--spacing) * 2); */
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.sellwild-tv ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
  padding-right: calc(var(--spacing) * 2);
  padding-top: calc(var(--spacing) * 2);
  box-sizing: border-box;
  margin-bottom: auto;
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  scroll-behavior: smooth;
}

.sellwild-tv ul::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome, Safari and Opera */
}

.sellwild-tv li {
  cursor: pointer;
}

.sellwild-tv li a {
  display: flex;
  margin-bottom: var(--spacing);
  padding-bottom: var(--spacing);
  text-decoration: none;
}

.sellwild-tv li:not(:last-child) a {
  border-bottom: 0.5px solid var(--white);
}

.sellwild-tv .tv-listing-img {
  width: 76px;
  height: 76px;
  object-fit: cover;
}

.sellwild-tv .listing-details {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-self: stretch;
  margin-left: calc(var(--spacing) / 2);
}

.sellwild-tv .listing-details-main {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: auto;
}

.sellwild-tv .listing-details-sub {
  width: 100%;
  display: flex;
  align-items: center;
}

.sellwild-tv .tv-listing-title {
  line-height: 1.2em;
  height: 2.4em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  color: var(--white);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 0;
}

.sellwild-controls-banner {
  position: absolute;
  top: 12px;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  justify-content: center;
}

.sellwild-controls {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}

.sellwild-tv-main-container .scroll-to-next {
 position: absolute;
 left: 0;
 right: 0;
 bottom: 40px;
 transform: translateY(-100%);
 width: 160px;
 height: 40px;
 border-radius: 20px;
 color: #fff;
 background-color: var(--blue);
 outline: none;
 border: none;
 display: flex;
 justify-content: center;
 align-items: center;
 margin: auto;
 cursor: pointer;
 flex-direction: column;

 font-size: 16px;
line-height: 1;
padding: 4px;
}

.sellwild-tv-main-container .scroll-to-next.hidden {
  display: none;
}

.sellwild-tv-main-container .scroll-to-next svg {
  width: 1em;
  height: 1em;
}

.sellwild-controls .progress {
  position: relative;
  overflow: visible;
  height: 10px;
  width: 100%;
  z-index: 1;
  margin: 0;
}

.sellwild-controls .progress-bar {
  appearance: none;
  position: absolute;
  content: '';
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
  box-shadow: none;
}

.sellwild-controls .progress-bar::-webkit-progress-bar {
  background-color: #eee;
}

.sellwild-controls .progress-bar::-webkit-progress-value {
  background-color: var(--blue);
}

sellwild-tv sellwild-video { 
  z-index: 2;
  position: absolute; 
  width: 100%; 
  height: 100%; 
  bottom: 0; 
  left: 0;
  background-color: rgba(0,0,0,0.9);
}

.sellwild-controls .progress-bar-seek {
  -webkit-appearance: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  appearance: none;
  background: none;
  margin: 0;
  padding: 0;
  border: none;
  box-shadow: none;
}

.sellwild-controls .progress-bar-seek::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  background-color: var(--blue);
  border: 2px solid #eee;
  border-radius: 10px;
}

.sellwild-controls .progress-ticks div {
  position: absolute;
  cursor: none;
  top: 0;
  width: 6px;
  height: 100%;
  background-color: #aaa;
}

.sellwild-controls .actions {
  display: flex;
}

.sellwild-controls .icon .rotate-180 {
  transform: rotateY(180deg);
}

.sellwild-controls .icon {
  width: 55px;
  height: 55px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0);
  transition: background-color 0.3s ease-in;
}

.sellwild-controls .icon:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.sellwild-controls .icon svg {
  width: 72%;
  height: 72%;
}

.sellwild-controls .icon svg.height-30 {
  width: 54%;
  height: 54%;
}

.sellwild-controls .icon svg[data-selector=play],
.sellwild-controls .icon svg[data-selector=pause],
.sellwild-controls .icon svg[data-selector=mute],
.sellwild-controls .icon svg[data-selector=unmute],
.sellwild-controls .icon svg[data-selector=enter-fullscreen],
.sellwild-controls .icon svg[data-selector=exit-fullscreen] {
  display: none;
}
.sellwild-controls .icon[data-state=paused] svg[data-selector=play],
.sellwild-controls .icon[data-state=playing] svg[data-selector=pause],
.sellwild-controls .icon[data-state=unmuted] svg[data-selector=unmute],
.sellwild-controls .icon[data-state=muted] svg[data-selector=mute],
.sellwild-controls .icon[data-state=not-fullscreen] svg[data-selector=enter-fullscreen],
.sellwild-controls .icon[data-state=is-fullscreen] svg[data-selector=exit-fullscreen] {
  display: block;
}

.sellwild-controls .timing {
  margin-right: auto;
}

.sellwild-current-listing a {
  position: absolute;
  bottom: 65px;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: var(--spacing);
  padding-top: calc(var(--spacing) * 4);
  box-sizing: border-box;
  text-decoration: none;
}

.sellwild-current-loader {
  position: absolute;
  top: 0;
  bottom: 60px;
  left: 0;
  right: 0;
  margin: auto;
  display: flex!important;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s ease-in, visibility 0s linear 0.3s;
}

.sellwild-current-loader.show {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.3s ease-in, visibility 0s linear;
}

.sellwild-current-loader:after {
  content: " ";
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 6px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: sellwild-current-loader 1.2s linear infinite;
}

@keyframes sellwild-current-loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.sellwild-current-listing a:not(:empty) {
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8));
}

.sellwild-tv .tv-listing-price {
  text-align: left;
  align-self: flex-end;
  background-color: var(--black);
  color: var(--white);
  padding: calc(var(--spacing) / 2) var(--spacing);
  display: block;
  font-size: 13px;
  margin-right: calc(var(--spacing) / 2);
}

.sellwild-tv .listing-link {
  margin-left: auto;
  text-align: right;
  white-space: nowrap;
  align-self: center;
  color: var(--white);
  font-size: 20px;
  text-decoration: underline;
}

.sellwild-card {
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  padding: calc(var(--spacing) * 1.5) calc(var(--spacing) * 2);
  overflow: hidden;
}

.sellwild-card:empty {
  display: none;
}

.sellwild-user {
  display: flex;
}

.sellwild-user .sellwild-avatar {
  background-color: var(--white);
  padding: calc(var(--spacing) / 2);
  box-sizing: border-box;
  box-shadow: 8px 10px 16px rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  position: relative;
  min-width: 100px;
  max-width: 100px;
  height: 100px;
}

.sellwild-user .sellwild-avatar .checkmark {
  position: absolute;
  bottom: 0;
  right: 0;
  box-shadow: 0 2px 4px rgba(0,0,0,.5);
  margin-left: 5px;
  cursor: pointer;
  min-width: 30px;
  height: 30px;
  background: var(--blue);
  border-radius: 100%;
  border: 1px solid var(--white);;
  justify-content: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sellwild-user .sellwild-avatar .checkmark svg {
  fill: var(--white);
  height: 16px;
  width: 16px;
}

.sellwild-user img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  display: block;
}

.sellwild-user .sellwild-user-info {
  margin-top: var(--spacing);
  margin-left: calc(var(--spacing) * 2);
}

.sellwild-user h4 {
  margin: 0;
  font-family: "Myriad Pro", sans-serif;
  font-size: 26px;
  color: var(--black);
  margin-bottom: 4px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.sellwild-user p {
  margin: 0;
  font-size: 14px;
  color: var(--black);
  margin-bottom: 8px;
  opacity: 0.6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sellwild-user button {
  margin: 0;
  display: inline-block;
  font-size: 14px;
  color: var(--white);
  background-color: var(--black);
  padding: calc(var(--spacing) / 1.5) calc(var(--spacing) * 1.5);
  border-radius: calc(var(--spacing) / 2);
  box-shadow: 4px 3px 9px rgba(0, 0, 0, 0.3);
  transform: translateY(0px);
  transition: box-shadow 0.3s ease-in, transform 0.3s ease-in;
  cursor: pointer;
  appearance: none;
  box-shadow: none;
  outline: none;
  border: none;
}

.sellwild-user a {
  text-decoration: none;
}

.sellwild-user button:hover {
  transform: translateY(2px);
  box-shadow: 2px 1px 4px rgba(0, 0, 0, 0.3);
}

.sellwild-search {
  position: relative;
  margin-bottom: calc(var(--spacing) * 1.5);
  overflow: hidden;
}

.sellwild-search input {
  width: 100%;
  height: 24px;
  border-radius: 12px;
  border: 1px solid var(--black);
  padding: 0 36px 0 12px;
  box-sizing: border-box;
}

.sellwild-search button {
  position: absolute;
  top: 0;
  right: 0;
  width: 36px;
  height: 24px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sellwild-search svg {
  fill: var(--black);
  height: 12px;
  width: 12px;
}

.sellwild-categories {
  display: flex;
  gap: var(--spacing);
  margin-bottom: auto;
}

.sellwild-categories>a {
  flex: 1;
  display: block;
  text-decoration: none;
}

.sellwild-categories>a>img {
  width: 100%;
  height: 100px;
  object-fit: cover;
  transform: translateY(0px);
  transition: transform 0.3s ease-in;
}

.sellwild-categories>a:hover>img {
  transform: translateY(-4px);
}

.sellwild-categories>a>p {
  margin: 0;
  color: var(--black);
  transform: translateY(0px);
  transition: transform 0.3s ease-in 0.1s;
}

.sellwild-categories>a:hover>p {
  transform: translateY(-4px);
}

.sellwild-cta {
  display: block;
  background-color: var(--black);
  padding: var(--spacing);
  text-align: center;
  text-decoration: none;
  transition: transform 0.3s ease-in!important;
  transform: translateY(0);
  cursor: pointer;
}

.sellwild-cta:hover {
  transform: translateY(-5px);
  text-decoration: none;
}

.sellwild-cta p {
  color: var(--white);
  font-weight: 300;
  font-size: 16px;
  margin: 0;
}

.sellwild-cta img {
  height: 36px;
}

.sellwild-next {
  position: relative;
  border: 2px solid var(--white);
  height: 108px;
  overflow: hidden;
}

.sellwild-next>video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(10px);
}

.sellwild-next>div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: calc(var(--spacing) / 2);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.sellwild-next>div:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.sellwild-next>div>video {
  width: 100px;
  height: 60px;
  align-self: center;
  object-fit: cover;
  margin: 4px 0;
}

.sellwild-next>div>p {
  position: relative;
  color: var(--white);
  font-size: 14px;
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  grid-gap: 4px;
}

.sellwild-next>div>p>img {
  height: 1em;
  object-fit: contain;
}

.sellwild-next>div>.play>svg {
  display: block;
  width: 14px;
  height: 14px;
  margin: 8px;
  margin-top: 7px;
  stroke: var(--white);
  fill: none;
}

.sellwild-next.coming-up {
  pointer-events: none;
}
.sellwild-next.coming-up .play {
  display: none;
}

.sellwild-next>div>.play {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  color: var(--white);
  border: 1px solid;
  box-sizing: border-box;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  transition: background-color 0.3s ease-in;
}

.sellwild-next>div>.play:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.slide-up {
  animation: slide-up ease-in both;
  animation-duration: var(--duration, 0.3s);
  animation-delay: var(--delay, 0);
}

.fade-in {
  animation: fade-in ease-in both;
  animation-duration: var(--duration, 0.3s);
  animation-delay: var(--delay, 0);
}

@keyframes slide-up {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}

@keyframes slide-down {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media screen and (max-width: 520px) {
  .sellwild-tv-wrapper {
    height: 600px;
  }
  .sellwild-tv-left {
    display: none;
  }
  .sellwild-current-listing {
    padding: calc(var(--spacing) * 2);
    padding-top: calc(var(--spacing) * 6);
    /* padding-bottom: calc(var(--spacing) * 6); */
    /* bottom: unset; */
    /* top: 0; */
  }
  /* .sellwild-current-listing:not(:empty) {
    background: linear-gradient(to top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8));
  } */
  .sellwild-wrapper .sellwild-current-listing .tv-listing-title {
    height: 1.2em;
  }
  .sellwild-wrapper .sellwild-current-listing .tv-listing-img {
    width: 48px;
    height: 48px;
  }
  .sellwild-current-listing .tv-listing-title {
    font-size: 16px;
  }
  .sellwild-current-listing .tv-listing-price {
    font-size: 14px;
  }
  .sellwild-current-listing .listing-link {
    font-size: 14px;
  }
  .sellwild-current-listing .listing-details-sub {
    margin-top: var(--spacing);
  }
  .sellwild-controls .icon {
    width: 30px;
    height: 30px;
  }
  .sellwild-current-listing a {
    bottom: 40px;
  }
  .sellwild-current-loader {
    bottom: 40px;
  }
}
@media screen and (max-width: 1100px) {
  .sellwild-tv-right {
    display: none;
  }
  .sellwild-tv-main-container .scroll-to-next {
    display: none;
  }
}

.sellwild-wrapper {
  position: relative; 
}
.sellwild-wrapper:not(.corner) .sellwild-tv-wrapper .close,
.sellwild-wrapper.corner.closed .sellwild-tv-wrapper .close {
  display: none;
}
.sellwild-wrapper.corner:not(.closed) .sellwild-tv-main-container .scroll-to-next {
  display: none;
}
.sellwild-wrapper.corner .sellwild-tv-wrapper .close {
  position: absolute;
  top: -12px;
  right: -12px;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  border: none;
  outline: none;
  background-color: #aaa;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 3;
}
@media screen and (max-width: 400px) {
  .sellwild-wrapper.corner .sellwild-tv-wrapper .close {
    right: 0;
  }
}
.sellwild-wrapper.corner:not(.closed) .sellwild-tv-main-container-inner {
  position: fixed;
  padding-top: unset;
  width: 400px;
  height: 225px;
  max-width: 100%;
  bottom: 0;
  left: 0;
  z-index: 1000;
}

/* .sellwild-wrapper.corner:not(.closed) .sellwild-tv-left, 
.sellwild-wrapper.corner:not(.closed) .sellwild-tv-right {
  display: none
} */
.sellwild-wrapper.corner:not(.closed) .sellwild-controls .icon {
  width: 30px;
  height: 30px;
}
.sellwild-wrapper.corner:not(.closed) .sellwild-current-listing a {
  bottom: 40px;
}
.sellwild-wrapper.corner:not(.closed) .sellwild-current-loader {
  bottom: 40px;
}

.tv-action-buttons {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  flex-direction: column;
  grid-gap: 24px;
}

/* .close-fullscreen { */
.tv-action-buttons button {
  width: 44px;
  height: 44px;
  border-radius: 22px;
  font-size: 32px;
  border: none;
  outline: none;
  background-color: var(--blue, #aaa);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

/* .close-fullscreen span { */
.tv-action-buttons button span {
  line-height: 0;
  display: block;
}

.tv-action-buttons button svg {
  width: 32px;
  height: 32px;
}

.sw-particle {
  z-index: 999999;
  position: fixed;
  background-color: #fff;
  border-radius: 100%;
  width: 10px;
  height: 10px;
  pointer-events: none;
}`